<template>
  <div class="app-content">
    <router-view />
    <LoginModal />
    <!--  充值弹窗-->
    <RechargeModal />
    <TurnVipModal />
  </div>
</template>
<script>
import { useWsMessageStore } from "@/store/wsMessage";
import { usePlayStatusStore } from "@/store/playStatus";
import LoginModal from "@/components/LoginModal/index.vue";
import RechargeModal from "@/components/RechargeModal/index.vue";
import GameStateMgr from "./js/game/GameStateMgr";
import { IStateType } from "./js/game/state/IGameState";
import TurnVipModal from "@/components/TurnVipModal/index.vue";
import { useRoute } from "vue-router";
import { watch, onMounted } from "vue";
import { logEvent } from "./js/firebasesdk";
import { getQueryString } from "./js/utils";

export default {
  components: { LoginModal, RechargeModal, TurnVipModal },
  beforeCreate() {
    window.gameStateMgr = new GameStateMgr(IStateType.FREE);
    useWsMessageStore().setup();
    usePlayStatusStore().setup();
  },
  setup() {
    const route = useRoute();
    // 监听路由变化
    watch(
      () => route.path,
      (newPath, oldPath) => {
        document.getElementById("app").classList.remove("vip-background");
        document.getElementById("app").classList.remove("down-backaground");
        if (newPath === "/VIP") {
          document.getElementById("app").classList.add("vip-background");
        } else if (newPath === "/DownLoad") {
          document.getElementById("app").classList.add("down-backaground");
        }
      }
    );
    onMounted(() => {
      const channel = getQueryString("promotion_source") || "";
      channel &&
        logEvent("dy_promotion_source", {
          channel,
        });
    });
  },
};
</script>
<style lang="scss">
.vip-background {
  width: 100%;
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  .app-content {
    position: relative;
    height: 540px;
    background-image: linear-gradient(
        180deg,
        rgba(18, 18, 18, 0) 0%,
        #121212 100%
      ),
      linear-gradient(
        90deg,
        rgba(178, 0, 255, 0.25) 0%,
        rgba(125, 78, 255, 0.25) 100%
      );
    .container.router-view {
      position: relative;
      overflow: hidden;
      &::after {
        content: "";
        width: 596px;
        height: 596px;
        position: absolute;
        top: -272px;
        right: -10%;
        // opacity: 0.45;
        background: url("@/assets/img/bg_pic_v@2x.png") 50% / cover no-repeat;
        // background: red;
        z-index: 0;
      }
    }
  }
}

.down-backaground {
  width: 100%;
  height: 100vh;
  background: url("@/assets/img/download-bg.jpg") 50% / cover no-repeat;
}
</style>
